import { useController, useFormContext } from 'react-hook-form'
import FormHelperText from '@mui/material/FormHelperText'
import Rating from './rating'

const ControlledRating = ({
	name: nameProp,
	onChange,
	onBlur,
	defaultChecked,
	noError,
	disabled: _disabled,
	...props
}) => {
	const formContext = useFormContext()
	const isSubmitting = formContext?.formState?.isSubmitting

	const {
		field: { onChange: controllerOnChange, onBlur: controllerOnBlur, value, name },
		fieldState: { error },
	} = useController({ name: nameProp, defaultValue: defaultChecked, required: props.required })

	const disabled = _disabled ?? isSubmitting

	return (
		<>
			<Rating
				onChange={(...args) => {
					controllerOnChange(...args)
					if (onChange) onChange(...args)
				}}
				onBlur={(...args) => {
					controllerOnBlur(...args)
					if (onBlur) onBlur(...args)
				}}
				value={parseInt(value)}
				name={name}
				disabled={disabled}
				{...props}
			/>
			{!noError && <FormHelperText error>{error?.message ? error?.message : ' '}</FormHelperText>}
		</>
	)
}

ControlledRating.defaultProps = {
	...Rating.defaultProps,
}

ControlledRating.propTypes = {
	...Rating.propTypes,
}

export default ControlledRating
